import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=3d8f65cb"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports